<template>
  <div class="container px-2 mx-auto dark:bg-gray-900">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    >
    </loading>
    <div class="flex flex-row space-x-6 rounded-t-xl">
      <div class="flex items-center justify-start">
        <h2
          class="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200 text-left"
        >
          Plan de Cuenta
        </h2>
      </div>
      <div class="flex items-center justify-end text-xl">
        <span v-if="reloading === 3" class="mr-6">
          <button
            v-if="activeRequest2"
            title="Recalcular montos totales de cuenta"
            class="py-2 px-2 font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-md hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
          >
            <i class="icon-arrows-cw animate-pulse mr-2" aria-hidden="true"></i
            >Actualizando Saldos
          </button>
          <button
            v-else
            v-on:click="updateAccountAmount()"
            title="Recalcular montos totales de cuenta"
            class="py-2 px-2 font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-md hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
          >
            <svg
              class="w-7 h-5"
              viewBox="0 0 100 99.999998"
              version="1.1"
              id="svg8"
              inkscape:version="1.0.2 (e86c870879, 2021-01-15)"
              sodipodi:docname="recalculate.svg"
            >
              <defs id="defs2" />
              <g
                inkscape:label="Layer 1"
                inkscape:groupmode="layer"
                id="layer1"
                transform="translate(-47.873076,-132.16815)"
              >
                <path
                  style="fill: #ffffff; stroke-width: 0.228527"
                  d="m 92.856111,232.02429 c -9.159275,-1.00824 -17.695169,-4.369 -25.12809,-9.89345 -2.785226,-2.0701 -7.677999,-6.96672 -9.74647,-9.75415 -10.921888,-14.71809 -13.14209,-33.48557 -5.933716,-50.158 0.668817,-1.54693 1.902887,-3.97447 2.742378,-5.39455 0.839491,-1.42008 1.498311,-2.60676 1.464042,-2.63706 -0.03427,-0.0303 -1.326059,0.13036 -2.870647,0.357 -3.710948,0.54454 -4.724872,0.25409 -5.310294,-1.52114 -0.315374,-0.95635 0.0024,-2.07208 0.80521,-2.82684 0.484781,-0.45579 1.30864,-0.6316 6.560939,-1.40004 3.303597,-0.48334 6.504656,-0.88119 7.113463,-0.88409 1.34292,-0.006 2.297599,0.59315 2.636961,1.65605 0.282327,0.88427 1.852823,12.09019 1.852823,13.22043 0,1.97114 -2.275424,3.12417 -4.040176,2.04728 -0.400312,-0.24428 -0.8325,-0.63985 -0.960418,-0.87906 -0.127917,-0.2392 -0.409634,-1.78787 -0.626038,-3.44149 -0.216404,-1.65361 -0.47017,-3.00657 -0.563926,-3.00657 -0.640126,0 -3.938949,6.59275 -5.224996,10.44223 -1.813009,5.42682 -2.407897,9.62588 -2.225983,15.71227 0.123837,4.14324 0.393554,6.16938 1.286626,9.66521 4.032382,15.78435 16.570343,28.2259 32.424819,32.17552 4.088411,1.01849 5.413646,1.16141 10.769117,1.16141 5.355465,0 6.680695,-0.14292 10.769105,-1.16141 4.28514,-1.0675 8.64043,-2.8546 12.11573,-4.97141 1.89126,-1.15198 2.89035,-1.33657 4.03306,-0.74519 1.22246,0.63266 1.65678,2.45767 0.87064,3.65841 -0.51723,0.79001 -2.34771,1.95623 -5.63013,3.58701 -4.64476,2.30761 -9.54538,3.86764 -14.62434,4.65541 -2.8754,0.44597 -9.863209,0.63304 -12.559689,0.33622 z m 38.563819,-16.00507 c -0.33724,-0.25195 -0.71873,-0.7888 -0.84776,-1.193 -0.28807,-0.90242 -1.85142,-12.10214 -1.85142,-13.26345 0,-2.4088 3.54871,-3.30806 4.89678,-1.24087 0.18279,0.2803 0.51031,1.87276 0.72783,3.5388 0.21752,1.66605 0.4722,3.02918 0.56595,3.02918 0.55717,0 3.80934,-6.31714 4.98531,-9.68363 1.88113,-5.38524 2.41614,-8.70827 2.41614,-15.00701 0,-5.35968 -0.14281,-6.68595 -1.1605,-10.77758 -1.25759,-5.05615 -3.2716,-9.58718 -6.24633,-14.05273 -6.80158,-10.21025 -17.04921,-16.86381 -29.59999,-19.21863 -2.51689,-0.47222 -9.537235,-0.65617 -12.35774,-0.3238 -6.376345,0.7514 -12.839271,2.92579 -17.95131,6.03956 -1.891261,1.15197 -2.890352,1.33658 -4.033059,0.74519 -1.259445,-0.65179 -1.672125,-2.5568 -0.808689,-3.73307 0.631177,-0.85988 3.767534,-2.75143 6.938806,-4.18484 16.829229,-7.60676 36.066192,-5.52505 50.853382,5.50307 2.89644,2.16014 7.74732,7.01485 9.90577,9.91357 12.27213,16.48115 13.36667,38.7595 2.75739,56.12395 -0.64372,1.05357 -1.14082,1.94191 -1.10469,1.97408 0.0362,0.0321 1.32947,-0.12695 2.87406,-0.3536 3.71094,-0.54454 4.72487,-0.2541 5.31029,1.52115 0.31537,0.95634 -0.003,2.07207 -0.80521,2.82683 -0.48479,0.45579 -1.30864,0.63159 -6.56094,1.40005 -6.94339,1.01587 -8.03387,1.06691 -8.90407,0.41678 z"
                  id="path26"
                  sodipodi:nodetypes="sscssscscccssssssssssssssssssssssssssssssccccscscsscss"
                />
                <path
                  style="fill: #ffffff; stroke-width: 0.282907"
                  d="m 112.35619,211.33611 c -1.03337,-1.03421 -1.19168,-1.81192 -1.19168,-5.85429 v -3.21934 h -3.6904 c -2.74553,0 -3.90279,-0.10993 -4.51995,-0.42932 -1.65431,-0.85614 -2.21311,-3.35395 -1.07445,-4.80264 0.9928,-1.26316 2.1136,-1.56049 5.88215,-1.56049 h 3.40265 v -3.4053 c 0,-3.77154 0.29709,-4.89321 1.55924,-5.8868 1.44756,-1.13956 3.94341,-0.5803 4.79889,1.07529 0.31914,0.61764 0.42898,1.7758 0.42898,4.52351 v 3.6933 h 3.2168 c 4.0155,0 4.81767,0.15982 5.8158,1.15872 1.45389,1.45506 1.20684,3.82526 -0.51984,4.98714 -0.88148,0.59316 -1.27303,0.64659 -4.73683,0.64659 h -3.77593 v 3.6933 c 0,5.02612 -0.65585,6.21237 -3.43474,6.21237 -1.09391,0 -1.47651,-0.14734 -2.16069,-0.83204 z m -41.065961,-1.07878 c -0.598962,-0.29946 -1.19417,-0.91344 -1.507414,-1.55498 -0.879634,-1.80158 -0.524854,-2.4937 3.23328,-6.30778 l 3.355714,-3.40565 -2.984888,-2.96227 c -3.328672,-3.30343 -3.793474,-3.99144 -3.793474,-5.61518 0,-2.09378 2.018846,-3.55564 4.165654,-3.01642 0.451098,0.11328 2.168323,1.57131 4.102688,3.48336 l 3.326864,3.28848 3.489196,-3.4522 c 3.20052,-3.16661 3.57601,-3.45221 4.538495,-3.45221 2.143509,0 3.566409,1.42401 3.566409,3.56921 0,0.96334 -0.28554,1.33917 -3.454689,4.54732 l -3.454689,3.49719 3.141112,3.17901 c 1.727614,1.74842 3.282214,3.45716 3.454688,3.79716 0.667569,1.31606 0.122434,3.27582 -1.161728,4.17595 -0.787603,0.55209 -2.551672,0.5705 -3.558378,0.0371 -0.420008,-0.22253 -2.097762,-1.75102 -3.728356,-3.39663 l -2.964704,-2.99204 -3.256816,3.24093 c -2.933684,2.91939 -4.173104,3.83624 -5.184086,3.83491 -0.184303,-2.5e-4 -0.780498,-0.22312 -1.324878,-0.49528 z m 8.133952,-31.92843 c -1.360208,-0.73864 -1.629626,-1.69245 -1.629626,-5.76933 v -3.6933 h -3.216822 c -4.015492,0 -4.817666,-0.15983 -5.815784,-1.15873 -1.45391,-1.45505 -1.206856,-3.82525 0.519832,-4.98713 0.881478,-0.59316 1.273028,-0.6466 4.736828,-0.6466 h 3.775946 v -3.69331 c 0,-5.0261 0.655844,-6.21235 3.434718,-6.21235 1.093902,0 1.476531,0.14735 2.160686,0.83205 1.03338,1.03419 1.191702,1.81191 1.191702,5.85428 v 3.21933 h 3.690386 c 2.745548,0 3.902794,0.10993 4.519954,0.42931 1.654294,0.85615 2.2131,3.35397 1.074446,4.80268 -0.992803,1.26313 -2.113594,1.56047 -5.882152,1.56047 h -3.402634 v 3.4053 c 0,3.77153 -0.297112,4.89321 -1.559254,5.8868 -0.912892,0.71863 -2.454318,0.79169 -3.598226,0.17053 z m 25.168869,-1.69811 c -0.98101,-0.53273 -1.62964,-1.777 -1.62964,-3.12618 0,-0.96326 0.28539,-1.33902 3.4495,-4.54207 l 3.44949,-3.49195 -3.28592,-3.32948 c -1.91053,-1.9359 -3.36738,-3.65447 -3.4806,-4.10592 -0.53881,-2.14849 0.92192,-4.16893 3.01404,-4.16893 1.62248,0 2.30994,0.46517 5.61076,3.79644 l 2.95995,2.98726 3.42819,-3.39184 c 3.41457,-3.37839 3.43352,-3.39186 4.77453,-3.39186 1.15409,0 1.48364,0.13743 2.30785,0.96226 0.8242,0.82485 0.9615,1.15469 0.9615,2.30967 0,1.34206 -0.0135,1.36102 -3.38918,4.7783 l -3.38916,3.43087 2.98488,2.96229 c 1.64171,1.62924 3.16683,3.30618 3.38918,3.72651 0.53296,1.00752 0.51457,2.77297 -0.0371,3.56121 -0.89942,1.2851 -2.85763,1.83072 -4.17266,1.16262 -0.33975,-0.17262 -2.04712,-1.72842 -3.79419,-3.4574 l -3.17648,-3.14358 -3.49445,3.4574 c -3.2865,3.25165 -3.56026,3.45672 -4.60042,3.44607 -0.60827,-0.006 -1.45432,-0.2005 -1.88009,-0.43169 z"
                  id="path26-6"
                  sodipodi:nodetypes="sscsssscsssscsssscsssssscsssscsssscssssscsssssscsssscsssscsssscssscsscsssscssssscsscsscsscc"
                />
              </g>
            </svg>
          </button>
        </span>
        <span>
          <!-- <button
            v-if="activeRequest"
            title="Recargar Listado Rápido"
            class="py-2 px-2 font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-md hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
          >
            <i class="icon-arrows-cw animate-pulse" aria-hidden="true"></i>
          </button>
          <button
            v-else
            v-on:click="getUpdateGeneralLedger()"
            title="Recargar Listado Rápido"
            class="py-2 px-2 font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-md hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
          >
            <i class="icon-arrows-cw" aria-hidden="true"></i>
          </button> -->
          <button
            title="Exportar Tabla"
            v-on:click="downAcc()"
            class="py-2 px-2 mr-6 font-medium leading-5 text-white transition-colors duration-150 bg-green-600 border border-transparent rounded-md active:bg-blue-600 hover:bg-green-400 focus:outline-none focus:shadow-outline-purple"
          >
            <i class="icon-download" aria-hidden="true"></i>
          </button>
        </span>
      </div>
    </div>

    <nav class="sticky container mx-auto w-full top-0">
      <div
        class="flex flex-row flex-shrink-0 items-center justify-start shrink-0 text-sm font-bold uppercase rounded-t-lg bg-gradient-to-t from-blue-600 to-blue-500 text-white"
      >
        <div class="flex items-center justify-center w-12 h-10 px-1">
          <span>N.</span>
        </div>
        <div class="flex items-center w-28 h-10 px-1">
          <span>Cuenta</span>
        </div>
        <div class="flex items-center w-96 h-10 px-1">
          <span>Descripción</span>
        </div>
        <!-- <div class="flex items-center flex-1 h-10 px-1"><span>Presupuesto</span></div> -->
        <div class="flex items-center flex-1 w-28 h-10 px-1">
          <span>Debe</span>
        </div>
        <div class="flex items-center flex-1 h-10 px-1">
          <span>Haber</span>
        </div>
        <div class="flex items-center flex-1 h-10 px-1">
          <span>Saldo</span>
        </div>
        <div class="flex items-center justify-center w-10 h-10 px-1">
          <span>Movim.</span>
        </div>
        <div class="flex items-center justify-center w-10 h-10 px-1">
          <span>N.</span>
        </div>
        <div class="flex items-center justify-center w-28 h-10 px-1">
          <span>Acciones</span>
        </div>
      </div>
    </nav>

    <div class="mt-0">
      <div class="w-full overflow-hidden shadow-xs">
        <div class="w-full overflow-x-auto">
          <!-- para generar plan de cuenta a futuro -->
          <div v-if="objAccount.length === 0" class="table-auto">
            <div
              class="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800"
            >
              <th class="px-2 py-3 w-full">
                <button @click="GenerateGeneralLeger(user.companyId)">
                  Plan De Cuenta
                </button>
              </th>
            </div>
          </div>

          <div class="overflow-hidden border-l-2 border-r-2">
            <div
              class="flex flex-shrink-0 justify-start text-sm hover:bg-blue-100 duration-150"
              v-for="(item, index) in objAccount"
              :key="index"
            >
              <div
                class="flex items-center pl-3 w-12 h-6 px-1 border-b border-gray-300"
              >
                <span>{{ index + 1 }}</span>
              </div>
              <div
                class="flex items-center w-28 h-6 px-1 border-b border-gray-300"
              >
                <span>{{ item.accountCode }}</span>
              </div>
              <div
                class="flex items-center text-left w-96 h-6 px-1 border-b border-gray-300 flex-wrap overflow-y-auto"
              >
                <button
                  v-if="editMode === index"
                  v-on:click="updateAcc(index, item)"
                  class="px-1 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-green-400 border border-transparent rounded-l-md active:bg-blue-600 hover:bg-green-500 focus:outline-none focus:shadow-outline-purple"
                >
                  <i class="icon-ok" aria-hidden="true"></i>
                </button>
                <button
                  v-if="editMode === index"
                  v-on:click="cancel(index, item)"
                  class="px-1 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-400 border border-transparent rounded-0 active:bg-blue-600 hover:bg-red-500 focus:outline-none focus:shadow-outline-purple"
                >
                  <i class="icon-cancel" aria-hidden="true"></i>
                </button>
                <input
                  v-if="editMode === index"
                  type="text"
                  v-model="item.accountName"
                  class="w-72 border-2 px-2 border-gray-300 rounded-r-md md:w-50"
                />
                <span v-else>{{ item.accountName }} </span>
              </div>
              <div
                class="flex items-center flex-1 h-6 px-1 border-b border-gray-300"
              >
                <span>{{
                  item.debit != 0
                    ? formatNumber(item.debit, ",", "$", true)
                    : " "
                }}</span>
              </div>
              <div
                class="flex items-center flex-1 h-6 px-1 border-b border-gray-300"
              >
                <span>{{
                  item.credit != 0
                    ? formatNumber(item.credit, ",", "$", true)
                    : " "
                }}</span>
              </div>
              <div
                class="flex items-center flex-1 h-6 px-1 border-b border-gray-300"
              >
                <span v-if="item.balance != 0">
                  {{
                    item.balance > 0
                      ? formatNumber(item.balance, ",", "$", true)
                      : `( ${formatNumber(item.balance * -1, ",", "$", true)} )`
                  }}
                </span>
              </div>
              <div
                class="flex items-center justify-center w-10 h-6 px-1 border-b border-gray-300"
              >
                <span>{{ item.isMovementAccount }}</span>
              </div>
              <div
                class="flex items-center justify-center w-10 h-6 px-1 border-b border-gray-300"
              >
                <span>{{ item.accountNature }}</span>
              </div>
              <div
                class="flex items-center justify-center w-28 h-6 px-1 border-b border-gray-300"
              >
                <span>
                  <a
                    v-on:click="editAcc(index)"
                    class="px-1 py-1 text-sm font-medium leading-5 text-blue-500 hover:text-white transition-colors duration-150 border border-transparent rounded-md active:bg-blue-600 hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
                    ><i class="icon-edit" aria-hidden="true"></i
                  ></a>
                </span>
                <span v-if="item.accountGroup === 4 || item.accountGroup === 5">
                  <a
                    v-on:click="showAddBudget(item)"
                    class="px-1 py-1 text-sm font-medium leading-5 text-blue-500 hover:text-white transition-colors duration-150 border border-transparent rounded-md active:bg-blue-600 hover:bg-blue-500 focus:outline-none focus:shadow-outline-purple"
                    ><i class="icon-attach" aria-hidden="true"></i
                  ></a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="modalBudget">
      <div class="p-4 semibold text-center">
        {{ accountCode }}
        {{ accountNameCode }}
        <!-- <span class="text-blue-700 font-bold"> modificación </span> del asiento -->
      </div>
      <div class="p-2">
        <input
          type="date"
          v-model="transactionDate"
          class="border-2 w-40 border-gray-300 rounded"
        />
        <Multiselect
          v-model="auxiliary"
          tag-placeholder="Add"
          placeholder="Aux"
          label="name"
          track-by="code"
          :options="ObjAuxiliary"
          :multiple="false"
          :taggable="true"
          @tag="addTag"
        ></Multiselect>
      </div>
      <div class=" ">
        <input
          type="text"
          v-model="amount"
          class="w-40 border-2 px-2 border-gray-300 rounded md:w-50"
          placeholder="100.50"
        />
      </div>
      <div class="text-sm w-full text-right p-3">
        <button
          @click="addbudget()"
          class="ml-2 px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-green-600 border border-transparent rounded-lg active:bg-blue-500 hover:bg-green-700 focus:outline-none focus:shadow-outline-purple"
        >
          Guardar
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
// import Multiselect from 'vue-multiselect'
// import router from '@/router'
// import Swal from 'sweetalert2'
import { mapState } from "vuex";
import { jsPDF } from "jspdf";
import Multiselect from "vue-multiselect";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ContentGeneralLedger",
  components: {
    Loading,
    Multiselect,
  },
  props: {},
  data() {
    return {
      activeRequest2: false,
      activeRequest: false,
      editMode: -1,
      loading: false,
      URL: process.env.VUE_APP_URL_ACC,
      URLAdm: process.env.VUE_APP_URL,
      error: false,
      objGerenalLeger: [],
      dateFrom: "",
      dateTo: "",
      account: "",
      amount: 0,
      numberAccTrans: "",
      objAccount: [],
      mutaObjAccount: [],
      // comboObjAccount:[],
      reloading: 0,
      auxiliary: null,
      account_id: null,
      accountNameCode: "",
      accountCode: "",
      accountNature: "",
      auxiliaryType: "contract",
      ObjAuxiliary: [],
      transactionDate: moment().format("YYYY-MM-DD"),
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapState(["user", "access_token", "year"]),
  },
  mounted() {
    this.getGeneralLedger();
    // this.updateAccountAmount();
    this.getAuxiliary();
  },
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    showAddBudget(value) {
      console.log(value);
      this.accountCode = value.accountCode;
      this.account_id = value.id;
      this.accountNameCode = value.accountName;
      (this.accountCopy = value.accountCopy),
        (this.accountNature = value.accountNature),
        this.$modal.show("modalBudget");
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.transaction.push(tag);
    },
    async getAuxiliary() {
      //
      if (this.auxiliaryType === "contract") {
        const URL = `${this.URLAdm}v1/contract`;
        const fetchConfig = {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.access_token.replace(/['"]+/g, "")}`,
          },
        };
        let params = {
          companyId: this.user.companyId,
        };
        // console.log(params)
        // try {
        let rsAccount = await Axios.post(URL, params, fetchConfig);
        console.log(rsAccount);
        // return
        const result = rsAccount.data;
        // console.log(result)
        this.ObjAuxiliary = result.map((item) => {
          // console.log(item.client.clientName)
          return {
            name: item.contractNumber + " - " + item.siteAddress,
            code: item.contractNumber,
          };
          // return { text: item.accountName, value: item.id}
        });
      }
    },
    formatNumber(number, separator = ",", symbol = "$", showSymbol = false) {
      number = parseFloat(number);
      number = number.toFixed(2);
      if (separator == ",") {
        let montoNuevo = number
          .toString()
          .replace(/\D/g, "")
          .replace(/([0-9])([0-9]{2})$/, "$1.$2")
          .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
        if (showSymbol) {
          return `${symbol}${montoNuevo}`;
        } else {
          return `${montoNuevo}`;
        }
      } else {
        let montoNuevo = number
          .toString()
          .replace(/\D/g, "")
          .replace(/([0-9])([0-9]{2})$/, "$1,$2")
          .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
        if (showSymbol) {
          return `${symbol}${montoNuevo}`;
        } else {
          return `${montoNuevo}`;
        }
      }
    },
    editAcc(index) {
      this.editMode = index;
    },
    async updateAcc(index, item) {
      let url = `${this.URL}updateAccount`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization : `Bearer ${this.access_token.replace(/['"]+/g, '')}`
        },
      };
      const params = {
        id: item.id,
        accountName: item.accountName,
        budget: item.budget,
        company: this.user.companyId,
        year: this.year,
      };
      let res = await Axios.patch(url, params, fetchConfig);
      // console.log(res)
      if (res.statusText === "OK") {
        this.editMode = -1;
        return;
      } else {
        this.getGeneralLedger();
      }
    },
    cancel(index, val) {
      // console.log(index)
      this.editMode = -1;
      this.getGeneralLedger();
    },
    async getGeneralLedger() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
      this.activeRequest = !this.activeRequest;
      const URL = `${this.URL}showAllCompanyAccountsFlatMode`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization : `Bearer ${this.access_token.replace(/['"]+/g, '')}`
        },
      };
      let params = {
        company_id: this.user.companyId,
        company: this.user.companyId,
        year: this.year,
      };
      try {
        const rsAccount = await Axios.post(URL, params, fetchConfig);
        this.objAccount = rsAccount.data.data;
        console.log(this.objAccount);
        // this.comboObjAccount = rsAccount.data.data.map(item => {
        // 	return { name: item.accountCode + ' - ' + item.accountName, code: item.id}
        // })
        if (rsAccount.statusText === "OK") {
          this.reloading = 3;
          this.activeRequest = !this.activeRequest;
        }
      } catch (error) {
        if (error.message == "Request failed with status code 422") {
          this.reloading = 1;
          this.activeRequest = !this.activeRequest;
        }
        console.log(error.name); //
        console.log(error.message); //
        console.log(error.foo); //
        console.log(error.stack); //
      }
      this.isLoading = false;
    },
    async addbudget() {
      this.activeRequest = !this.activeRequest;
      const URL = `${this.URL}addAccountBudget`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization : `Bearer ${this.access_token.replace(/['"]+/g, '')}`
        },
      };
      let params = {
        company: this.user.companyId,
        year: this.year,
        account_id: this.account_id,
        accountCode: this.accountCode,
        accountCopy: this.accountCopy.toString(),
        description: this.accountNameCode,
        company_id: this.user.companyId,
        user_id: this.user.userId,
        user_name: this.user.fullName,
        auxiliary: this.auxiliary.code,
        auxiliary_type: "budget",
        budget: this.amount,
        transactionDate: this.transactionDate,
        accountNature: this.accountNature,
      };
      console.log(params);
      try {
        const rsAccount = await Axios.post(URL, params, fetchConfig);
        // this.objAccount = rsAccount.data.data;
        console.log(rsAccount);
        // this.comboObjAccount = rsAccount.data.data.map(item => {
        // 	return { name: item.accountCode + ' - ' + item.accountName, code: item.id}
        // })
        if (rsAccount.statusText === "OK") {
          (this.account_id = null),
            (this.accountCode = ""),
            (this.accountCopy = ""),
            (this.accountNameCode = ""),
            this.user.companyId,
            this.user.userId,
            this.user.fullName,
            (this.auxiliary = null),
            (this.auxiliary_type = ""),
            (this.accountNature = ""),
            (this.amount = 0),
            (this.transactionDate = moment().format("YYYY-MM-DD"));
          this.$modal.hide("modalBudget");
        }
      } catch (error) {
        if (error.message == "Request failed with status code 422") {
        }
        console.log(error.name); //
        console.log(error.message); //
        console.log(error.foo); //
        console.log(error.stack); //
      }
    },
    async downAcc() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;

        let doc = new jsPDF("p", "pt", "letter");
        let lineaY = 100;
        let lineaX = 70;
        let positionCursor = 100;
        let positionCompany = (this.user.companyName.length / 2) * 6;
        positionCompany = parseInt(positionCompany);
        positionCompany = 240 - positionCompany;
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("ACCOUNT", lineaX, lineaY - 15); //descripcion
        doc.text("DESCRIPTION", lineaX + 110, lineaY - 15); //descripcion
        doc.text("GENERAL LEDGER", lineaX + 191, lineaY - 70); //descripcion
        doc.text(
          this.user.companyName,
          lineaX + positionCompany - 6,
          lineaY - 55
        ); //descripcion
        // console.log(positionCompany);
        // return
        let pageCount = doc.internal.getNumberOfPages();
        // // let currentPage
        // currentPage = doc.internal.getCurrentPageInfo().pageNumber; // página actual
        doc.text("Page", lineaX + 470, lineaY - 70); //descripcion
        doc.text(pageCount + "", lineaX + 500, lineaY - 70); //descripcion
        this.objAccount.forEach((element) => {
          pageCount = doc.internal.getNumberOfPages();
          doc.setFontSize(7);
          doc.setFont("helvetica", "bold");
          // console.log(element.accountCode)
          if (positionCursor > 730) {
            // currentPage = doc.internal.getCurrentPageInfo().pageNumber; // página actual
            lineaY = 100;
            positionCursor = 100;
            doc.addPage();
            doc.setFontSize(10);
            doc.text("GENERAL LEDGER", lineaX + 191, lineaY - 70); //descripcion
            doc.text(
              this.user.companyName,
              lineaX + positionCompany - 6,
              lineaY - 55
            ); //descripcion
            doc.setFont("helvetica", "bold");
            doc.text("ACCOUNT", lineaX, lineaY - 15); //descripcion
            doc.text("DESCRIPTION", lineaX + 110, lineaY - 15); //descripcion
            doc.text("Page", lineaX + 470, lineaY - 70); //descripcion
            doc.text(pageCount + 1 + "", lineaX + 500, lineaY - 70); //descripcion
            doc.setFontSize(7);
            doc.setFont("helvetica", "bold");
          }
          doc.text(element.accountCode, lineaX, lineaY); //ACCOUNT
          doc.text(element.accountName, lineaX + 110, lineaY); //descripcion
          lineaY = lineaY + 10;
          positionCursor = positionCursor + 10;
        });
        this.isLoading = false;
        // console.log(pageCount)
        doc.save("GENERAL LEDGER - " + this.user.companyName + ".pdf");
      }, 50);
    },
    async updateAccountAmount() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
      this.activeRequest2 = !this.activeRequest2;
      const URL = `${this.URL}calculateAllAccountsBalances`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization : `Bearer ${this.access_token.replace(/['"]+/g, '')}`
        },
      };
      let params = {
        company_id: this.user.companyId,
        company: this.user.companyId,
        year: this.year,
      };
      try {
        const rsAccount = await Axios.post(URL, params, fetchConfig);
        console.log(rsAccount);
        if (rsAccount.statusText === "OK") {
          alert(rsAccount.data.data.message);
          this.activeRequest2 = !this.activeRequest2;
          this.getGeneralLedger();
        }
      } catch (error) {
        console.log(error.name); //
        console.log(error.message); //
        console.log(error.stack); //
      }
      this.isLoading = false;
      // try { reloading
    },
    async getUpdateGeneralLedger() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
      this.getGeneralLedger();
      this.isLoading = false;
    },
    async GenerateGeneralLeger(companyId) {
      // console.log(companyId);
      const URL = `${this.URL}showAllCompanyAccountsHierarchicalMode/${8}`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization : `Bearer ${this.access_token.replace(/['"]+/g, '')}`
        },
      };
      // try { reloading
      const rsAccount = await Axios.get(URL, fetchConfig);
      this.objAccount = rsAccount.data.data;
      // console.log(rsAccount);
      // this.comboObjAccount = rsAccount
    },
  },
};
</script>